import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import HeroPage from './components/pages/HeroPage';
import VisionPage from './components/pages/VisionPage';
import ProductEcosystem1 from './components/pages/ProductEcosystem1';
import ProductEcosystem2 from './components/pages/ProductEcosystem2';
import ProductEcosystem3 from './components/pages/ProductEcosystem3';
import WhyGmatrixs from './components/pages/WhyGmatrixs';
import DevelopersPage from './components/pages/DevelopersPage';
import EcosystemPage from './components/pages/EcosystemPage';
import JoinUsPage from './components/pages/JoinUsPage';
import ScrollIndicator from './components/ScrollIndicator';

import './App.css';

const pages = [
  { id: 'hero', component: HeroPage, title: 'Home' },
  { id: 'vision', component: VisionPage, title: 'Our Vision' },
  { id: 'product1', component: ProductEcosystem1, title: 'SDK' },
  { id: 'product2', component: ProductEcosystem2, title: 'Chain' },
  { id: 'product3', component: ProductEcosystem3, title: 'Marketplace' },
  { id: 'why', component: WhyGmatrixs, title: 'Why Gmatrixs' },
  { id: 'developers', component: DevelopersPage, title: 'For Developers' },
  { id: 'ecosystem', component: EcosystemPage, title: 'Ecosystem' },
  { id: 'join', component: JoinUsPage, title: 'Join Us' }
];

function App() {
  const [currentPage, setCurrentPage] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const [touchStartY, setTouchStartY] = useState(0);

  useEffect(() => {
    const handleWheel = (e) => {
      if (isScrolling) return;
      
      e.preventDefault();
      setIsScrolling(true);
      
      if (e.deltaY > 0 && currentPage < pages.length - 1) {
        setCurrentPage(prev => prev + 1);
      } else if (e.deltaY < 0 && currentPage > 0) {
        setCurrentPage(prev => prev - 1);
      }
      
      setTimeout(() => setIsScrolling(false), 1000);
    };

    const handleKeyDown = (e) => {
      if (isScrolling) return;
      
      if (e.key === 'ArrowDown' && currentPage < pages.length - 1) {
        setIsScrolling(true);
        setCurrentPage(prev => prev + 1);
        setTimeout(() => setIsScrolling(false), 1000);
      } else if (e.key === 'ArrowUp' && currentPage > 0) {
        setIsScrolling(true);
        setCurrentPage(prev => prev - 1);
        setTimeout(() => setIsScrolling(false), 1000);
      }
    };

    const handleTouchStart = (e) => {
      setTouchStartY(e.touches[0].clientY);
    };

    const handleTouchEnd = (e) => {
      if (isScrolling) return;
      
      const touchEndY = e.changedTouches[0].clientY;
      const diff = touchStartY - touchEndY;
      
      if (Math.abs(diff) > 50) {
        setIsScrolling(true);
        
        if (diff > 0 && currentPage < pages.length - 1) {
          setCurrentPage(prev => prev + 1);
        } else if (diff < 0 && currentPage > 0) {
          setCurrentPage(prev => prev - 1);
        }
        
        setTimeout(() => setIsScrolling(false), 1000);
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [currentPage, isScrolling, touchStartY]);

  const goToPage = (pageIndex) => {
    if (isScrolling) return;
    setIsScrolling(true);
    setCurrentPage(pageIndex);
    setTimeout(() => setIsScrolling(false), 1000);
  };

  const CurrentPageComponent = pages[currentPage].component;

  return (
    <div className="App relative w-full h-screen overflow-hidden bg-black">
      <Navigation 
        pages={pages} 
        currentPage={currentPage} 
        onPageChange={goToPage}
      />
      
      <ScrollIndicator 
        currentPage={currentPage} 
        totalPages={pages.length}
        onPageChange={goToPage}
      />
      
      <AnimatePresence mode="wait">
        <motion.div
          key={currentPage}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ 
            duration: 0.8, 
            ease: [0.4, 0, 0.2, 1] 
          }}
          className="w-full h-full"
        >
          <CurrentPageComponent />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default App;